class SearchPopup {
  constructor() {
    this.storageKey = 'hmns_recent_searches';
    this.popup = document.querySelector('[data-search-popup]');
    if (!this.popup) return;

    this.input = this.popup.querySelector('[data-search-input]');
    this.inputClear = this.popup.querySelector('[data-search-input-clear]');
    this.form = this.popup.querySelector('[data-search-form]');
    this.closeButtons = this.popup.querySelectorAll('[data-search-popup-close]');
    this.recentListEl = this.popup.querySelector('[data-recent-searches-list]');
    this.recentEmptyEl = this.popup.querySelector('[data-recent-empty]');
    this.clearAllBtn = this.popup.querySelector('[data-clear-all-recent]');
    this.defaultContent = this.popup.querySelector('[data-default-content]');
    this.liveResults = this.popup.querySelector('[data-live-results]');
    this.liveResultsGrid = this.popup.querySelector('[data-live-results-grid]');
    this.liveSpinner = this.popup.querySelector('[data-live-spinner]');
    this.liveResultsTitle = this.popup.querySelector('[data-live-results-title]');
    this.liveViewAll = this.popup.querySelector('[data-live-view-all]');
    this.viewAllLink = this.popup.querySelector('[data-view-all-link]');
    this.viewAllCount = this.popup.querySelector('[data-view-all-count]');

    this.maxRecent = 6;
    this.debounceTimer = null;

    this.init();
  }

  init() {
    // Header search triggers
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-search-trigger]');
      if (trigger) {
        e.preventDefault();
        this.open();
      }
    });

    // Close triggers
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.classList.contains('is-open')) {
        this.close();
      }
    });

    // Clear input button handler
    if (this.inputClear) {
      this.inputClear.addEventListener('click', () => {
        if (this.input) {
          this.input.value = '';
          this.inputClear.style.display = 'none';
          clearTimeout(this.debounceTimer);
          this.showDefaultContent();
          this.input.focus();
        }
      });
    }

    // Form submit -> save to recent search
    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        const query = this.input.value.trim();
        if (query) {
          this.saveRecentSearch(query);
        }
      });
    }

    // Live search input handler (debounce)
    if (this.input) {
      this.input.addEventListener('input', () => {
        const query = this.input.value.trim();
        clearTimeout(this.debounceTimer);

        if (this.inputClear) {
          this.inputClear.style.display = query.length > 0 ? 'flex' : 'none';
        }

        if (query.length === 0) {
          this.showDefaultContent();
          return;
        }

        this.debounceTimer = setTimeout(() => {
          this.fetchPredictiveResults(query);
        }, 300);
      });
    }

    // Popular pills click handler -> auto fill, live search & save
    this.popup.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-popular-keyword]');
      if (pill) {
        const keyword = pill.dataset.popularKeyword;
        if (this.input && keyword) {
          this.input.value = keyword;
          if (this.inputClear) this.inputClear.style.display = 'flex';
          this.fetchPredictiveResults(keyword);
          this.saveRecentSearch(keyword);
          this.input.focus();
        }
      }
    });

    // Clear all recent searches
    if (this.clearAllBtn) {
      this.clearAllBtn.addEventListener('click', () => {
        this.clearAllRecentSearches();
      });
    }

    // Load initial recent searches from LocalStorage
    this.renderRecentSearches();
  }

  open() {
    // Automatically close mobile menu drawer if open
    const drawer = document.querySelector('[data-mobile-drawer]');
    const drawerOverlay = document.querySelector('[data-mobile-drawer-overlay]');
    if (drawer) drawer.classList.remove('header__mobile-drawer--open');
    if (drawerOverlay) drawerOverlay.classList.remove('header__mobile-drawer-overlay--open');

    const stickyHeader = document.querySelector('[data-sticky-header]');
    const isDesktop = window.innerWidth > 998;

    if (isDesktop && stickyHeader) {
      stickyHeader.classList.add('header-sticky--search-open');
      stickyHeader.classList.remove('header-sticky--hidden');

      const headerElem = document.querySelector('.header') || stickyHeader;
      const headerHeight = headerElem ? headerElem.offsetHeight : 75;

      this.popup.style.top = `${headerHeight}px`;
      this.popup.style.height = `calc(100vh - ${headerHeight}px)`;
      this.popup.style.height = `calc(100dvh - ${headerHeight}px)`;
    } else {
      this.popup.style.top = '0px';
      this.popup.style.height = '100vh';
      this.popup.style.height = '100dvh';
    }

    this.popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.renderRecentSearches();

    if (this.input && this.inputClear) {
      this.inputClear.style.display = this.input.value.trim().length > 0 ? 'flex' : 'none';
    }

    setTimeout(() => {
      if (this.input) {
        this.input.focus();
      }
    }, 150);
  }

  close() {
    this.popup.classList.remove('is-open');
    document.body.style.overflow = '';

    const stickyHeader = document.querySelector('[data-sticky-header]');
    if (stickyHeader) {
      stickyHeader.classList.remove('header-sticky--search-open');
    }
  }

  // --- LocalStorage Recent Searches Management ---
  getRecentSearches() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch (e) {
      return [];
    }
  }

  saveRecentSearch(query) {
    if (!query) return;
    const cleanQuery = query.trim();
    let searches = this.getRecentSearches();

    // Filter out duplicates (case-insensitive)
    searches = searches.filter((item) => item.toLowerCase() !== cleanQuery.toLowerCase());

    // Add to the beginning
    searches.unshift(cleanQuery);

    // Limit maximum searches
    searches = searches.slice(0, this.maxRecent);

    try {
      localStorage.setItem(this.storageKey, JSON.stringify(searches));
    } catch (e) {}

    this.renderRecentSearches();
  }

  removeRecentSearch(keyword) {
    let searches = this.getRecentSearches();
    searches = searches.filter((item) => item.toLowerCase() !== keyword.toLowerCase());
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(searches));
    } catch (e) {}
    this.renderRecentSearches();
  }

  clearAllRecentSearches() {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (e) {}
    this.renderRecentSearches();
  }

  renderRecentSearches() {
    const searches = this.getRecentSearches();

    if (!this.recentListEl) return;

    if (searches.length === 0) {
      this.recentListEl.innerHTML = '';
      if (this.recentEmptyEl) this.recentEmptyEl.style.display = 'block';
      if (this.clearAllBtn) this.clearAllBtn.style.display = 'none';
      return;
    }

    if (this.recentEmptyEl) this.recentEmptyEl.style.display = 'none';
    if (this.clearAllBtn) this.clearAllBtn.style.display = 'inline-block';

    this.recentListEl.innerHTML = searches
      .map(
        (term) => `
        <li class="search-popup__recent-item">
          <a href="/search?q=${encodeURIComponent(term)}" class="search-popup__recent-link" data-recent-query="${encodeURIComponent(term)}">
            ${term}
          </a>
          <button type="button" class="search-popup__recent-remove" aria-label="Remove search" data-remove-recent="${encodeURIComponent(term)}">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </li>
      `
      )
      .join('');

    // Attach click handlers to recent item links and remove buttons
    this.recentListEl.querySelectorAll('[data-recent-query]').forEach((link) => {
      link.addEventListener('click', () => {
        const query = decodeURIComponent(link.dataset.recentQuery);
        this.saveRecentSearch(query);
      });
    });

    this.recentListEl.querySelectorAll('[data-remove-recent]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const keyword = decodeURIComponent(btn.dataset.removeRecent);
        this.removeRecentSearch(keyword);
      });
    });
  }

  // --- Predictive Search / Live Results ---
  showDefaultContent() {
    if (this.defaultContent) this.defaultContent.style.display = 'flex';
    if (this.liveResults) this.liveResults.style.display = 'none';
    if (this.liveSpinner) this.liveSpinner.style.display = 'none';
  }

  async fetchPredictiveResults(query) {
    if (!query) {
      this.showDefaultContent();
      return;
    }

    if (this.defaultContent) this.defaultContent.style.display = 'none';
    if (this.liveResults) this.liveResults.style.display = 'block';
    if (this.liveSpinner) this.liveSpinner.style.display = 'flex';
    if (this.liveResultsTitle) this.liveResultsTitle.textContent = `SEARCH RESULTS FOR "${query.toUpperCase()}"`;

    const limit = parseInt(this.popup.dataset.liveLimit, 10) || 6;

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${limit}&resources[options][unavailable_products]=last`
      );
      const data = await response.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];

      this.renderLiveProducts(products.slice(0, limit), query);
    } catch (err) {
      console.error('Error fetching search suggestions', err);
      if (this.liveResultsGrid) {
        this.liveResultsGrid.innerHTML = `<div class="search-popup__no-results">Something went wrong while searching.</div>`;
      }
    } finally {
      if (this.liveSpinner) this.liveSpinner.style.display = 'none';
    }
  }

  renderLiveProducts(products, query) {
    if (!this.liveResultsGrid) return;

    if (products.length === 0) {
      this.liveResultsGrid.innerHTML = `<div class="search-popup__no-results" style="grid-column: 1 / -1;">No products found for "${query}".</div>`;
      if (this.liveViewAll) this.liveViewAll.style.display = 'none';
      return;
    }

    // Fetch rich product card markup via product.card view template
    const promises = products.map((p) => {
      const handle = p.handle;
      return fetch(`/products/${handle}?view=card`)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const card = doc.querySelector('.collection-tabs-card');
          if (card) {
            return `<div class="search-popup__product-item">${card.outerHTML}</div>`;
          }
          // Fallback simple card if card template fails
          return `
            <div class="search-popup__product-item">
              <article class="collection-tabs-card">
                <div class="collection-tabs-card__media">
                  <a href="${p.url}" class="collection-tabs-card__media-link">
                    <img src="${p.image || ''}" alt="${p.title}" class="collection-tabs-card__image collection-tabs-card__image--primary" loading="lazy">
                  </a>
                </div>
                <div class="collection-tabs-card__content">
                  <p class="collection-tabs-card__type">${p.type || ''}</p>
                  <h3 class="collection-tabs-card__title"><a href="${p.url}">${p.title}</a></h3>
                  <p class="collection-tabs-card__price">${window.theme && typeof window.theme.formatMoney === 'function' ? window.theme.formatMoney(p.price) : p.price}</p>
                </div>
              </article>
            </div>
          `;
        })
        .catch(() => '');
    });

    Promise.all(promises).then((items) => {
      this.liveResultsGrid.innerHTML = items.join('');
      
      // Save search term on clicking any product result
      this.liveResultsGrid.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          this.saveRecentSearch(query);
        });
      });

      if (this.liveViewAll && this.viewAllLink) {
        this.liveViewAll.style.display = 'block';
        this.viewAllLink.href = `/search?q=${encodeURIComponent(query)}`;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.searchPopupInstance = new SearchPopup();
});
